import React from 'react'
import '../css/CloseButton.css'

export default function CloseButton({ buttonClass }) {
    return <button className={'c-button ' + buttonClass}>Close</button>
}
